import { render, staticRenderFns } from "./SlCustomerDetail.vue?vue&type=template&id=84512158&lang=pug&"
import script from "./SlCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./SlCustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SlCustomerDetail.vue"
export default component.exports